// extracted by mini-css-extract-plugin
export var addButton = "_my-0";
export var border = "_my-8";
export var check = "_my-h";
export var danger = "_my-6";
export var dropdownContainer = "_my-1";
export var editModalBody = "_my-j";
export var footerContainer = "_my-i";
export var fullWidth = "_my-a";
export var hide = "_my-9";
export var icon = "_my-3";
export var input = "_my-7";
export var inputFlex = "_my-b";
export var inputWrapper = "_my-c";
export var manualFocus = "_my-5";
export var optionButton = "_my-4";
export var pillWrapper = "_my-e";
export var pointer = "_my-2";
export var showOverflow = "_my-f";
export var tagsFlex = "_my-d";
export var xButton = "_my-g";